import SearchResultEventItem from './SearchResultEventItem';

const SearchResultEvent = ({
    showResult,
    events,
    onSearchResultItemEnter,
    onSearchResultItemLeave,
    onSearchResultItemClicked,
    selectedEvent
}) => {

    const handleMouseEnter = (event, index) => {
        if (onSearchResultItemEnter) {
            onSearchResultItemEnter(event, index);
        }
    };

    const handleMouseLeave = (event, index) => {
        if (onSearchResultItemLeave) {
            onSearchResultItemLeave(event, index);
        }
    };

    const handleClick = (event, index) => {
        if (onSearchResultItemClicked) {
            onSearchResultItemClicked(event, index);
        }
    };

    return (
        <div className='search-result-container'>
            {showResult ? (
                <>
                    <div className='search-result-heading'>
                        <span>Partner in Ihrer Nähe</span>
                        <strong>{events.length} {events.length === 1 ? 'Ergebnis' : 'Ergebnisse'}</strong>
                    </div>
                    <div className='search-result-items-container'>
                        {Object.values(events).map((event, index) => (
                            <SearchResultEventItem
                                key={index}
                                event={event}
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                onClick={handleClick}
                                index={index}
                                isSelected={selectedEvent && selectedEvent.id === event.id}
                            />
                        ))}
                    </div>
                </>
            ) : (
                <div className='search-result-notice px-4 py-3'>Bitte geben Sie einen Ort ein, um E3/DC-Fachpartner Events in Ihrer Nähe zu finden.</div>
            )}
        </div>
    );
};

export default SearchResultEvent;
